module.exports = __webpack_public_path__ + "static/media/painaulait.1db109ec.jpeg";